export const ACTIVITY_BOOLEAN_CHOICES = [
  { id: '1', name: 'Активен' },
  { id: '0', name: 'Не активен' },
];
